<template>
    <div style="background-color: #fafafa;">
		<van-nav-bar title="暖气余额表" left-text="返回"  left-arrow @click-left="onClickLeft" fixed></van-nav-bar>
		<div class="psiConfirmCont">
			<van-search class="search-box" shape="round" v-model="value" placeholder="请输入搜索关键词" show-action @search="onSearch()" @input="onSearch()"
						@cancel="onSearch()" @clear="onSearch()">
				<div slot="action" style="color: #1890ff;" @click="onPersonalSearch()">自定义</div>
			</van-search>
			<van-pull-refresh v-model="refreshing" @refresh="onRefresh">
				<van-list v-model="loading" :finished="finished" @load="onLoad" class="listBox" finished-text="没有更多了">
					<div v-for="(item, index) in list" class="card" :key="item.barcodeIds">
						<table class="layout" style="width: 100%;" >
							<tr style="width: 100%;" >
								<td colspan="2">
									<div class="header">
										<span class="title">品牌：{{item.brandName}}</span>
									</div>
								</td>
							</tr>
							<tr style="width: 100%;">
								<td colspan="2" class="content" style="width: 90%;">
									<p><span>系列—型号：</span><span>{{item.categoryName}}—{{item.skuName}}</span></p>
								</td>
							</tr>
							<tr style="width: 100%;" >
								<td style="width: 40%;" class="content"><span>片数：</span><span>{{item.pieces}}</span></td>
								<td style="width: 50%;" class="content"><span>高度分类：</span><span>{{item.centerCategoryname}}</span></td>
							</tr>
							<tr style="width: 100%;" >
								<td style="width: 40%;" class="content"><span>高度：</span><span>{{item.centerSpacing}}</span></td>
								<td style="width: 50%;" class="content"><span>接口口径：</span><span>{{item.calibername}}</span></td>
							</tr>
							<tr style="width: 100%;">
								<td style="width: 40%;" class="content"><span>颜色：</span><span>{{item.colorname}}</span></td>
								<td style="width: 50%;" class="content"><span>进水方式：</span><span>{{item.waterFlowname}}</span></td>
							</tr>
							<tr style="width: 100%;">
								<td colspan="2" class="content"><p><span>特殊定制：</span><span>{{item.isSpecials}}</span></p></td>
							</tr>
							<tr style="width: 100%;">
								<td style="width: 40%;" class="content"><span>数量：</span></td>
								<td style="width: 50%;"><span style="font-weight: bold;color:#1890ff;">{{item.quantity}}</span></td>
							</tr>
							<tr style="width: 100%;">
								<td colspan="2" class="content"><p><span>货架：</span><span>{{item.positionname}}</span></p></td>
							</tr>
						</table>
					</div>
				</van-list>
			</van-pull-refresh>
		</div>
    </div>
</template>

<script>
    import {Tab, Tabs, Panel, Button, List, Search, Popup, PullRefresh, NavBar, Stepper, Toast, Checkbox, CheckboxGroup, Dialog} from 'vant';
	import dealerOrderService from "../../service/dealerOrderService";
    import {formatDictionary} from "../../utils/dictionary";
    export default {
        data: function () {
            return {
                list: [],
                loading: false,
                finished: false,
                pageIndex: 0,
                refreshing: false,
				value: "",
				data: {},
            }
        },
      
        components: {
            [Tab.name]: Tab,
            [Tabs.name]: Tabs,
            [Button.name]: Button,
            [PullRefresh.name]: PullRefresh,
            [Panel.name]: Panel,
            [List.name]: List,
            [Search.name]: Search,
            [Popup.name]: Popup,
            [Stepper.name]: Stepper,
			[NavBar.name]: NavBar,
			[Checkbox.name]: Checkbox,
			[CheckboxGroup.name]: CheckboxGroup
        },
		created: function () {
			this.data.radCategory = this.$route.query.radCategory || "";
			this.data.radId = this.$route.query.radId || "";
			this.data.pieces = this.$route.query.pieces || "";
			this.data.centerCategory = this.$route.query.centerCategory || "";
			this.data.centerSpacing = this.$route.query.centerSpacing || "";
			this.data.caliber = this.$route.query.caliber || "";
			this.data.color = this.$route.query.color || "";
			this.data.waterFlow = this.$route.query.waterFlow || "";
			this.data.isSpecials = this.$route.query.isSpecials || "";
		},
        methods: {
            async onLoad() {
                this.pageIndex++;
                let resp = await dealerOrderService.getSkuInventoryList(this.pageIndex, this.value, this.data);
                formatDictionary(resp.data.Data.data, resp.data.Data.dictionary);
				resp.data.Data.data.forEach(item => {
					if(item.isSpecials && item.isSpecials.length > 22){
						let temp = item.isSpecials;
						item.isSpecials = temp.substring(0, 22);
						item.isSpecials += "...";
					}
					if(item.positionname && item.positionname.length > 22){
						let temp = item.positionname;
						item.positionname = temp.substring(0, 22);
						item.positionname += "...";
					}
				});
                this.loading = false;
                this.refreshing = false;
                this.list = [...this.list, ...resp.data.Data.data];
                this.finished = resp.data.Data.total <= this.list.length;
            },
            onRefresh() {
                this.finished = false;
                this.loading = true;
                this.pageIndex = 0;
                this.list = [];
                this.onLoad();
            },
			onSearch() {
				this.finished = false;
				this.loading = true;
				this.pageIndex = 0;
				this.list = [];
				this.onLoad();
			},
			onPersonalSearch(){
				this.$router.push({path:"searchDetail", query: {type: "main"}});
			},
			onClickLeft(){
				this.$router.push("invIndex");
			}
        }
    };

</script>
<style>
	.card p {
		margin:10px 0;
	}
	.card p>span:first-child {
		flex: 0 0 4rem;
		text-align: right;
		margin-right: 20px;
	}
	.van-pull-refresh__head{
		display: none;
	}
	.van-checkbox__label{
		color: white;
	}
	.recordBox {
		padding: 0.5rem 0;
		box-sizing: border-box;
		margin-top: 2rem;
		bottom:0;
		position:fixed;
		width: 100%;
	}
	.psiConfirmCont{
		width:100%;
		margin:0 auto;
		margin-top:100px;
		overflow: hidden;
		padding-bottom: 150px;
	}
</style>